var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "b-form",
        {
          attrs: { "data-vv-scope": "activity-form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit()
            }
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-title", { staticClass: "mt-3 mb-75" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.activity.id ? "Editar" : "Nueva") +
                    " Actividad "
                )
              ]),
              _c(
                "b-form-group",
                {
                  staticClass: "mb-3",
                  attrs: { label: "Nombre", "label-for": "name" }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      id: "name",
                      placeholder: "Nombre",
                      name: "name",
                      state: _vm.errors.has("activity-form.name") ? false : null
                    },
                    model: {
                      value: _vm.activity.name,
                      callback: function($$v) {
                        _vm.$set(_vm.activity, "name", $$v)
                      },
                      expression: "activity.name"
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(
                      " " + _vm._s(_vm.errors.first("activity-form.name")) + " "
                    )
                  ])
                ],
                1
              ),
              _c(
                "b-form-checkbox",
                {
                  staticClass: "custom-control-info float-right mb-2",
                  attrs: { name: "check-button", switch: "" },
                  model: {
                    value: _vm.showDescriptionPreview,
                    callback: function($$v) {
                      _vm.showDescriptionPreview = $$v
                    },
                    expression: "showDescriptionPreview"
                  }
                },
                [
                  _c(
                    "span",
                    { staticClass: "switch-icon-left" },
                    [_c("feather-icon", { attrs: { icon: "TypeIcon" } })],
                    1
                  ),
                  _c(
                    "span",
                    { staticClass: "switch-icon-right" },
                    [_c("feather-icon", { attrs: { icon: "PenToolIcon" } })],
                    1
                  )
                ]
              ),
              _c(
                "b-form-group",
                {
                  staticClass: "mb-3",
                  attrs: { label: "Descripción", "label-for": "description" }
                },
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      id: "description",
                      name: "description",
                      placeholder: "Descripción",
                      rows: "4",
                      state: _vm.errors.has("activity-form.description")
                        ? false
                        : null
                    },
                    model: {
                      value: _vm.activity.description,
                      callback: function($$v) {
                        _vm.$set(_vm.activity, "description", $$v)
                      },
                      expression: "activity.description"
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.errors.first("activity-form.description")) +
                        " "
                    )
                  ])
                ],
                1
              ),
              _vm.showDescriptionPreview
                ? _c("div", {
                    staticClass: "border markdown rounded mb-3 px-4 py-3",
                    domProps: {
                      innerHTML: _vm._f("markdown")(_vm.activity.description)
                    }
                  })
                : _vm._e(),
              _c("ListUser", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "mb-3",
                attrs: {
                  label: "Usuario asignado",
                  name: "targetUserId",
                  "data-vv-as": "usuario asignado",
                  danger: _vm.errors.has("activity-form.targetUserId"),
                  "danger-text": _vm.errors.first("activity-form.targetUserId")
                },
                model: {
                  value: _vm.activity.targetUserId,
                  callback: function($$v) {
                    _vm.$set(_vm.activity, "targetUserId", $$v)
                  },
                  expression: "activity.targetUserId"
                }
              }),
              _vm.editMode
                ? _c("ListSystemActivityStatus", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "listSystemActivityStatus",
                    staticClass: "mb-3",
                    attrs: {
                      label: "Estado de sistema",
                      name: "statusValue",
                      danger: _vm.errors.has("activity-form.statusValue"),
                      "danger-text": _vm.errors.first(
                        "activity-form.statusValue"
                      )
                    },
                    model: {
                      value: _vm.activity.statusValue,
                      callback: function($$v) {
                        _vm.$set(_vm.activity, "statusValue", $$v)
                      },
                      expression: "activity.statusValue"
                    }
                  })
                : _vm._e(),
              _c("ListCompanyActivityStatus", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "listCompanyActivityStatus",
                staticClass: "mb-3",
                attrs: {
                  "parent-value": _vm.activity.statusValue,
                  label: "Estado de compañia",
                  name: "companyStatusValue",
                  "data-vv-as": "estado de compañía",
                  danger: _vm.errors.has("activity-form.companyStatusValue"),
                  "danger-text": _vm.errors.first(
                    "activity-form.companyStatusValue"
                  )
                },
                model: {
                  value: _vm.activity.companyStatusValue,
                  callback: function($$v) {
                    _vm.$set(_vm.activity, "companyStatusValue", $$v)
                  },
                  expression: "activity.companyStatusValue"
                }
              }),
              _c(
                "b-form-group",
                {
                  staticClass: "mb-3",
                  attrs: { label: "Fecha de Vencimiento", "label-for": "date" }
                },
                [
                  _c("b-form-datepicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      name: "date",
                      "data-vv-as": "fecha de vencimiento",
                      min: _vm.minDate,
                      state: _vm.errors.has("activity-form.date")
                        ? false
                        : null,
                      "label-help":
                        "Puede usar las flechas del teclado y espacio"
                    },
                    model: {
                      value: _vm.activity.expiredAt,
                      callback: function($$v) {
                        _vm.$set(_vm.activity, "expiredAt", $$v)
                      },
                      expression: "activity.expiredAt"
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(
                      " " + _vm._s(_vm.errors.first("activity-form.date")) + " "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { "400": true }
                        }
                      ],
                      attrs: { type: "submit", variant: "primary" }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.editMode ? "Editar" : "Crear") + " "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }